// Components
import { Button, Image, IconPen, IconShareSmall, Link, IconFilledPlayFat, Spacer } from '@tracklib/kit'
import { Avatar } from 'kit'

// Hooks
import { useProfile } from 'modules/profile/hooks'

// Types
import type { Beat as BeatType } from 'types'

import styles from './beat.css'

const Beat = ({ beat }: { beat: BeatType }) => {
  const profile = useProfile()
  const path = `/beat/${beat.id}`
  return (
    <li className={styles.beat}>
      <div className={styles.cover}>
        <Image
          image={beat.cover || '/static/images/default-cover-large.png'}
          absolute
          imageWidths={[64, 128, 130, 260, 520]}
          sizes="(min-width: 769px) 130px, 50px"
          alt={`${beat.title} cover art`}
        />
        <button onClick={() => alert('play')} className={styles.playButton}>
          <IconFilledPlayFat />
        </button>
      </div>
      <div className={styles.content}>
        <header className={styles.header}>
          <div>
            <Link to={path}>
              <p className={styles.title}>{beat.title}</p>
            </Link>
            <Link to={`/user/${beat.user}/`} className={styles.owner}>
              <Avatar id={beat.user} image={beat.avatar} className={styles.avatar} disabled />
              {beat.alias}
            </Link>
          </div>
          <div className={styles.buttons}>
            {beat.user === profile.user && (
              <>
                <Button to={`/yoursongs/${beat.user_song}/sharing/`} size="small" variant="outline">
                  <IconPen />
                  Edit
                </Button>
                <Spacer size={16} />
              </>
            )}
            <Button to="share" query={{ url: path }} size="small" modal>
              <IconShareSmall />
              Share
            </Button>
          </div>
        </header>
        <div>
          <div className={styles.waveform}>waveform</div>
        </div>
      </div>
    </li>
  )
}

export default Beat
